<template lang="pug">
  #main-footer
    p {{$t('footer.line1')}}
    p {{$t('footer.line2')}}
    p 
      a(:href="`mailto:${$t('login.contract.link')}`" target="_blank") {{ $t('login.contract.link') }}
    
    
</template>

<script>
export default {
  name: 'Footer'
}
</script>
